module.exports = __webpack_public_path__ + "media/images/order_btn_l-1802f7a35a8da9128fdba9e92267f78a.gif";